import test_image from '../../../data/test_image.json'

class WindowsScan {

    scanImageWindows = async (options = {}) => {
        if (window?.electron?.scanImage) {
            return window.electron.scanImage(options)
        }
        const fileData = await window.electron.wiaScan()
        return fileData
    };

    scanImageWindowsTest = async () => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('returning test image');
                resolve(test_image['src']);
            }, 10000);
        });
    };

    detectDoubleSidedScanners = async () => {
        if (!window?.electron?.detectDoubleSidedScanners) {
            return { available: false, count: 0, error: 'Not in Electron environment' };
        }
        return window.electron.detectDoubleSidedScanners();
    };

    scanImageDoubleSided = async (options = {}) => {
        if (!window?.electron?.scanImageDoubleSided) {
            throw new Error('Double-sided scanning not available');
        }

        const result = await window.electron.scanImageDoubleSided(options);

        if (!result.success) {
            throw new Error(result.error || 'Double-sided scan failed');
        }

        // Return file paths array: ['/tmp/device_1.jpg', '/tmp/device_2.jpg']
        return result.images;
    };

    scanImageDoubleSidedTest = async () => {
        // Return test file paths for development
        console.log('Using test mode for double-sided scan');
        await new Promise(resolve => setTimeout(resolve, 10000)); // 10 second delay

        // Return mock file paths - in production these would be actual temp files
        return [
            '/tmp/InstaGrainX/test_device_1.jpg',
            '/tmp/InstaGrainX/test_device_2.jpg'
        ];
    };

    selectDoubleSidedImages = async () => {
        if (!window?.electron?.selectImageFile) {
            throw new Error('File selection not available in this environment');
        }

        const filePaths = await window.electron.selectImageFile();

        if (!filePaths || filePaths.length === 0) {
            return null; // User cancelled
        }

        if (filePaths.length !== 2) {
            throw new Error(`Please select exactly 2 images for double-sided analysis. You selected ${filePaths.length} image(s).`);
        }

        // Validate file extensions
        const validExtensions = ['jpg', 'jpeg', 'png', 'tiff'];
        for (const filePath of filePaths) {
            const ext = filePath.split('.').pop().toLowerCase();
            if (!validExtensions.includes(ext)) {
                throw new Error(`Invalid file type: ${ext}. Please select images with extensions: ${validExtensions.join(', ')}`);
            }
        }

        // Return array of file paths ready for upload
        return filePaths;
    };
}

const windowsScan = new WindowsScan();

export default windowsScan;
